import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Eye, EyeOff, Loader2, CheckCircle2, Mail } from 'lucide-react'
import api from '../../services/api'

export default function RegisterPage() {
  const { t } = useTranslation()
  const [form, setForm] = useState({ bedrijfsnaam: '', email: '', wachtwoord: '', bevestig: '', taal: 'nl' })
  const [laden, setLaden] = useState(false)
  const [fout, setFout] = useState(null)
  const [klaar, setKlaar] = useState(false)
  const [toonWw, setToonWw] = useState(false)

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  async function submit(e) {
    e.preventDefault()
    setFout(null)
    if (form.wachtwoord !== form.bevestig) { setFout('Wachtwoorden komen niet overeen.'); return }
    if (form.wachtwoord.length < 8) { setFout('Wachtwoord moet minimaal 8 tekens bevatten.'); return }

    setLaden(true)
    try {
      await api.post('/auth/register', { bedrijfsnaam: form.bedrijfsnaam, email: form.email, wachtwoord: form.wachtwoord, taal: form.taal })
      setKlaar(true)
    } catch (err) {
      setFout(err.response?.data?.detail || 'Registratie mislukt. Probeer opnieuw.')
    } finally { setLaden(false) }
  }

  if (klaar) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-canvas dark:bg-gray-900 p-4">
        <div className="r11-card r11-card-pad shadow-xl max-w-md w-full text-center">
          <Mail className="w-12 h-12 mx-auto text-accent mb-4" />
          <h2 className="text-xl font-bold text-ink dark:text-white mb-2">Controleer uw e-mail</h2>
          <p className="text-muted mb-4">We hebben een activatielink gestuurd naar <strong>{form.email}</strong>.</p>
          <p className="text-sm text-faint mb-6">Controleer ook uw spam-map als u de e-mail niet vindt.</p>
          <Link to="/login" className="text-accent text-sm hover:underline">Terug naar inloggen</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas dark:bg-gray-900 p-4">
      <div className="r11-card r11-card-pad shadow-xl max-w-md w-full">
        <h1 className="text-2xl font-bold text-ink dark:text-white mb-1">Maak uw Orion account</h1>
        <p className="text-sm text-muted mb-6">Gratis registreren — geen creditcard nodig.</p>

        {fout && <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-control p-3 mb-4 text-sm text-red-600 dark:text-red-400">{fout}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="r11-label">Bedrijfsnaam *</label>
            <input required value={form.bedrijfsnaam} onChange={e => set('bedrijfsnaam', e.target.value)} className="r11-input" placeholder="Schrijnwerkerij Janssen" />
          </div>
          <div>
            <label className="r11-label">E-mailadres *</label>
            <input required type="email" value={form.email} onChange={e => set('email', e.target.value)} className="r11-input" placeholder="jan@janssen.be" />
          </div>
          <div className="relative">
            <label className="r11-label">Wachtwoord *</label>
            <input required type={toonWw ? 'text' : 'password'} value={form.wachtwoord} onChange={e => set('wachtwoord', e.target.value)} className="r11-input pr-10" placeholder="Min. 8 tekens, 1 hoofdletter, 1 cijfer" />
            <button type="button" onClick={() => setToonWw(!toonWw)} className="absolute right-3 top-7 text-muted hover:text-ink dark:hover:text-white">{toonWw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
          </div>
          <div>
            <label className="r11-label">Wachtwoord bevestigen *</label>
            <input required type="password" value={form.bevestig} onChange={e => set('bevestig', e.target.value)} className="r11-input" />
          </div>
          <div>
            <label className="r11-label">Taal</label>
            <select value={form.taal} onChange={e => set('taal', e.target.value)} className="r11-select">
              <option value="nl">Nederlands</option>
              <option value="fr">Francais</option>
            </select>
          </div>
          <button type="submit" disabled={laden} className="btn-primary w-full justify-center py-3 disabled:opacity-50">
            {laden ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />}
            {laden ? 'Bezig...' : 'Registreer'}
          </button>
        </form>
        <p className="text-center text-sm text-muted mt-4">Al een account? <Link to="/login" className="text-accent hover:underline">Inloggen</Link></p>
      </div>
    </div>
  )
}
